import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';
import { CmsContentService } from 'src/app/services/cms-content.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { SwiperOptions } from 'swiper';
import SwiperCore, {
  Navigation,
  A11y,
  EffectFade,
  Keyboard,
  Pagination,
} from 'swiper'; // install Swiper modules
SwiperCore.use([Navigation, A11y, EffectFade, Keyboard, Pagination]);

export enum cmsComponentName {
  ADDITIONAL_BENEFITS = 'additional-benefits',
  CONTEXT_NAVIGATION = 'context-navigation',
  MAIN_TEXT = 'main-text'
}

@Component({
  selector: 'app-cfm-addon-detail',
  templateUrl: './cfm-addon-detail.component.html',
  styleUrls: ['./cfm-addon-detail.component.scss']
})
export class CfmAddonDetailComponent implements OnInit {
  @Input('data') data: any;
  cmsUrlCode: string;
  cmsContent: any;
  sku: any;
  isArabic: any;
  public cmsComponentName = cmsComponentName;
  swiperConfig: SwiperOptions = {
    navigation: false,
    keyboard: true,
    scrollbar: false,
    pagination: {
      el: '.cfm__swiper',
      clickable: true,
    },
    slidesPerView: 1,
    spaceBetween: 16,
    breakpoints: {
      992: { slidesPerView: 3, spaceBetween: 24 },
    },
  };

  constructor(
    private appInitService: ApplicationInitializationService,
    private modalController: ModalController,
    private CCS: CmsContentService,
    private UTS: UtilitiesService) { }

  ngOnInit(): void {
    this.isArabic = this.UTS.getLocaleLanguage().toLocaleLowerCase() === 'ar';
    this.sku = this.data?.data?.sku;
    let url = this.appInitService?.environmentConfig?.CMS_URL_NEW_FRAGMENTPATH + this.data.data?.cmsUrl + 'master';
    if (this.UTS.getLocaleLanguage() == 'ar') {
      url = this.appInitService.environmentConfig.CMS_URL_NEW_FRAGMENTPATH + this.data.data?.cmsUrl + this.UTS.getLocaleLanguage();
    }
    setTimeout(() => {
      this.CCS.newFragemnetContentService(url).subscribe(
        (result: any) => {
          this.cmsContent = result?.data?.bauPopupMainSecByPath?.item;
        },
        (error) => {
        }
      );
    }, 0)

  }

  dismiss() {
    this.modalController.dismiss();
  }
}
